exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe[data-v-69531d41]{width:100%;height:100%;border:none}[data-v-69531d41] .el-dialog__body{height:calc(100% - 55px);padding:0 !important}[data-v-69531d41] .el-input--small{width:50%}\n", ""]);

// exports
